<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-pause-circle-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm-3 12a1 1 0 011 1v18a1 1 0 01-1 1h-2a1 1 0 01-1-1V15a1 1 0 011-1h2zm8 0a1 1 0 011 1v18a1 1 0 01-1 1h-2a1 1 0 01-1-1V15a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconPauseCircleFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
